/**
 * Pinia store — the single home of GvG planner board state, backed by the
 * GraphQL API.
 *
 * This stable entry point delegates construction to
 * `gvgPlannerStoreCore.ts`, cross-cutting derived/live state to
 * `gvgPlannerStoreComposition.ts`, and the flat compatibility surface to
 * `gvgPlannerStorePublicApi.ts`.
 *
 * Public API is preserved across the refactor — every ref, getter, action
 * from the original `gvgPlannerStore.ts` is exposed with the same name +
 * signature. Only the *internal* file layout changed.
 */
import { defineStore } from 'pinia'

import { useGvgPlannerStoreComposition } from './gvgPlannerStoreComposition'
import { createGvgPlannerStorePublicApi } from './gvgPlannerStorePublicApi'

// Re-exports — preserve the public symbols the components used to import
// from this file (see the original monolith's export block).
export {
  POOL_ROOM_ID,
  STATIC_POOL_GROUP_IDS,
  POOL_DEFAULT_GROUP_ID,
  MAX_TAGS_PER_PLAYER,
  MIN_MAX_PLAYERS,
  MAX_MAX_PLAYERS,
  MAX_SAVED_BUILDS,
} from '../lib/boardInvariants'
export { UnsupportedActionError } from '../lib/boardInvariants'

export const useGvgPlannerStore = defineStore('gvg-planner', () =>
  createGvgPlannerStorePublicApi(useGvgPlannerStoreComposition()),
)
